import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentQuantumDto extends EpimsBaseEntityDto {
  IncidentQuantumName: string;
  DistributorFactorValue: number;
  DistributorFactorName: string;
  SubscriptionUserId: string;
  Version: number;
}
